import axios, {AxiosError} from "axios";
import { API_URL } from "../constant";
import { FecthAccountResult} from "../constant";

export async function FectchAccounting(licenseNumber: string): Promise<FecthAccountResult> {

    try {
        const token = localStorage.getItem("token")
        
        const data ={licenseNumber: licenseNumber}
        const config = {
            headers: {
              Authorization: `Bearer ${token}`, // Bearer token
            },
          };
      
        const response = await axios.post(
          `${API_URL}api/accounting/getAcct`,
          data,
          config
        );
    
        if (response.status === 200)
        {
            console.log(`Fetch accounting success, ${response.data.length}`);
            return { success: true, record: response.data };
        }
        else{
            return { success: false, errorMsg: "Unexpected status code" };
        }
    } catch (err) {
        const error = err as AxiosError;
        if (error.response) {
            return { success: false, errorMsg: `"Server Error:"${error.response.status}` };
        } else if (error.request) {
            return { success: false, errorMsg: "No response received from server" };
        } else {
            return { success: false, errorMsg: `Error:, ${error.message}` };
        }
    }
}